import { render, staticRenderFns } from "./order-status-item.vue?vue&type=template&id=1a808290&scoped=true&"
import script from "./order-status-item.vue?vue&type=script&lang=js&"
export * from "./order-status-item.vue?vue&type=script&lang=js&"
import style0 from "./order-status-item.vue?vue&type=style&index=0&id=1a808290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a808290",
  null
  
)

export default component.exports